import React, { useContext, useState } from "react";
import { Button, Col, Row, Spin } from "antd";
import styles from "../../index.module.scss";
import PhotoItem from "../../../components/PhotoItem";
import AsideBlock from "../../../components/AsideBlock";
import PhotoListModal from "../../../components/PhotoListModal";
import PhotoDetail from "../../../components/PhotoListModal/components/PhotoDetail";
import { InvigilationCtx } from "../../../context";
import { getExamStudentFaceInfo } from "../../../../../../service/exam";
import useExamInfo from "../../../Hook/useExamInfo";

export default function AsidePhotoList() {
    const { currentData } = useContext(InvigilationCtx);

    const [showModal, setShowModal] = useState(false);
    const [current, setCurrent] = useState("");

    const [data, { loading }] = useExamInfo(
        getExamStudentFaceInfo,
        currentData
    );

    return (
        <AsideBlock
            title="抓拍记录"
            count={data?.studentFaceList.length}
            extra={
                <Button
                    type="link"
                    className={styles.button}
                    onClick={() => setShowModal(true)}>
                    查看更多&gt;
                </Button>
            }>
            <Spin spinning={loading}>
                <Row>
                    {data?.studentFaceList?.slice(0, 6).map((item, index) => (
                        <Col key={index} span={8}>
                            <PhotoItem
                                time={item.time}
                                url={item.url}
                                onClick={() => setCurrent(item.url)}
                            />
                        </Col>
                    ))}

                    {data?.studentFaceList?.length === 0 && (
                        <Col span={24}>无抓拍记录</Col>
                    )}
                </Row>
            </Spin>

            <PhotoListModal
                photos={data?.studentFaceList || []}
                visible={showModal}
                onCancel={() => setShowModal(false)}
            />

            <PhotoDetail
                visible={!!current}
                photo={current}
                onCancel={() => setCurrent("")}
            />
        </AsideBlock>
    );
}
